//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCentrosCostos } from "@/typings/store/plugins/easyFirestore/centrosCostos";

const getters: GetterTree<StateCentrosCostos, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const centrosCostos = {
    firestorePath: "dev/v1/centrosCostos",
    firestoreRefType: "collection",
    moduleName: "centrosCostos",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default centrosCostos;
